import {logger} from '../../../logger';
import React from 'react';
import {observable, action, computed, makeObservable, runInAction} from 'mobx';
import {observer} from 'mobx-react';
import store from '../../s';
import * as data from '../../data';
import {checkout} from '../../../api';
import {CheckoutInputElement, checkoutFieldDomIds} from '../inputs/checkoutInputs';
import {addressHasStates, isKnownCountryCode, redesignCountryList, selectLostItsValue, stateOptions, stateValueForCountry} from '../inputs/addressStates';
import {isCheckoutRedesign} from '../../ab-redesign';
import {billingDefaultApplies, markBillingChoice} from '../payment/ab-redesign-billing';
import * as checkoutUtil from '../../checkoutUtil';
import ModalSimple from '../../../global/modal-simple';
import s from '../../s';
import {Portal} from '../../../util';
import {ICheckoutAddressType, ICheckoutStep} from '../../i';
declare var modalOpen: any;
declare var Awesomplete: any;

@observer
export default class ShippingWrite extends React.Component {
    @observable loading: boolean = false;
    @observable focusedCountry: boolean = false;
    @observable focusedState: boolean = false;
    @observable focusedAddressBook: boolean = false;
    @observable focusedAddressType: boolean = false;

    constructor(props) {
        super(props);
        this.handleAddressTypeChange = this.handleAddressTypeChange.bind(this);
        this.save = this.save.bind(this);
        this.handleChangeCountry = this.handleChangeCountry.bind(this);
        this.syncMore = this.syncMore.bind(this);
        this.syncMoreCompany = this.syncMoreCompany.bind(this);
        this.placesInit = this.placesInit.bind(this);
        this.handleChangeAddressBook = this.handleChangeAddressBook.bind(this);
        this.initShipAddressBook = this.initShipAddressBook.bind(this);
        this.handleChangeShippingState = this.handleChangeShippingState.bind(this);
        this.loading = false;
        s.places_start = new Date();
        s.places_end = new Date();
        makeObservable(this);
    }

    private placesInputListeners: Array<{el: HTMLInputElement; handler: EventListener}> = [];

    async componentDidMount() {
        if (isCheckoutRedesign(store.checkout.isMyFrames)) {
            // First, so the flag is in place before this card's first paint (the places call below is awaited on phones).
            await this.applyBillingDefaultAtShipping();
        }
        if (window.innerWidth < 960) {
            await checkout('places-autocomplete');
            await this.placesInit();
        }
        this.initShipAddressBook();
    }

    componentWillUnmount() {
        this.placesInputListeners.forEach(({el, handler}) => el.removeEventListener('input', handler));
        this.placesInputListeners = [];
    }

    @action
    handleChangeCountry = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const select = e.target;
        const code = select.value;
        // An autofill that sends a country name or code the list does not have leaves the select on no option: React
        // would then show the first option (Afghanistan) while the store holds '', and the state field would turn into
        // a text box. Keep the country the form had instead.
        if (selectLostItsValue(select) || !isKnownCountryCode(code)) {
            select.value = store.checkout.ship.addr.country.value;
            return;
        }
        store.uiCheckout.stateRequiredShip = code === 'US' || code === 'CA';
        store.checkout.ship.addr.country.value = code;
        // A state from the previous country's list would be shown as the new list's first option while the store kept
        // the old value; make the two agree.
        store.checkout.ship.addr.state.value = stateValueForCountry(code, store.checkout.ship.addr.state.value);
        store.checkout.ship.addr.state.valid.isError = false;
    };

    /**
     * Redesign: the "billing address is the same" box on this card starts ticked unless the shopper decided for this
     * cart already (or an express flow filled billing). 'checkout-sync' carries the flag to the server, whose full-copy
     * replies to the shipping submits would otherwise reset it; the sync is sent even when the shell already set the
     * flag client-side, since the server may not have it yet.
     */
    @action
    applyBillingDefaultAtShipping = async () => {
        if (!billingDefaultApplies()) {
            return;
        }
        store.checkout.billing.addrSameAsShip = true;
        await checkout('checkout-sync');
    };

    @action
    toggleBillingSameAsShip = async () => {
        markBillingChoice();
        store.checkout.billing.addrSameAsShip = !store.checkout.billing.addrSameAsShip;
        await checkout('checkout-sync');
    };

    @action
    handleChangeAddressBook = (e: React.ChangeEvent<HTMLSelectElement>) => {
        store.checkout.ship.AddressID = parseInt(e.target.value, 10);
        store.setShippingAddressToBook();
    };

    @action
    initShipAddressBook = () => {
        let initToShip = store.checkout.isMyFrames && !store.checkout.myframes_isDropShip && store.checkout.AddressBookAddresses != null && store.checkout.AddressBookAddresses.length > 0;
        if (!initToShip) {
            initToShip = !store.checkout.myframes_isDropShip && store.checkout.AddressBookAddresses != null && store.checkout.AddressBookAddresses.length > 0 && store.checkout.ship.AddressID < 1;
        }

        if (initToShip) {
            const a = store.checkout.AddressBookAddresses.filter(x => x.isShipping);
            if (a.length > 0) {
                store.checkout.ship.AddressID = a[0].AddressID;
                store.setShippingAddressToBook();
            }
        }

        if (store.checkout.isMyFrames && !store.checkout.myframes_isDropShip && initToShip) {
            const a = store.checkout.AddressBookAddresses.filter(x => x.isBilling);
            if (a.length > 0) {
                store.checkout.billing.AddressID = a[0].AddressID;
                store.setBillingAddressToBook();
            }
        }
    };

    @computed get isCountryWithStates() {
        return addressHasStates(store.checkout.ship.addr);
    }

    @action
    handleAddressTypeChange = (e: any) => {
        store.checkout.ship.addressType = parseInt(e.target.value, 10);
    };

    @action
    handleChangeShippingState = (e: any) => {
        const select = e.target as HTMLSelectElement;
        if (selectLostItsValue(select)) {
            // Autofill sent a state the list does not have (see handleChangeCountry): keep the current selection.
            select.value = store.checkout.ship.addr.state.value;
            return;
        }
        store.checkout.ship.addr.state.value = e.target.value;
        let _ii = e.target.options.selectedIndex;
        let _id = parseInt(e.target.options[_ii].getAttribute('data-id'), 10);
        if (_id === 1) {
            store.checkout.ship.addr.companyName.value = 'Armed Forces Africa';
        } else if (_id === 2) {
            store.checkout.ship.addr.companyName.value = 'Armed Forces Americas';
        } else if (_id === 3) {
            store.checkout.ship.addr.companyName.value = 'Armed Forces Canada';
        } else if (_id === 4) {
            store.checkout.ship.addr.companyName.value = 'Armed Forces Europe';
        } else if (_id === 5) {
            store.checkout.ship.addr.companyName.value = 'Armed Forces Middle East';
        } else if (_id === 6) {
            store.checkout.ship.addr.companyName.value = 'Armed Forces Pacific';
        } else {
            if (store.checkout.ship.addr.companyName.value.startsWith('Armed')) {
                store.checkout.ship.addr.companyName.value = '';
                store.checkout.ship.addr.addrShowMoreCompany = false;
            }
        }
        store.checkout.ship.addr.state.valid.isError = false;
    };

    @action
    save = async () => {
        if (store.checkout.ship.addr.state.value === 'AL1') {
            store.checkout.ship.addr.state.valid.isError = true;
            store.checkout.ship.addr.state.valid.msg = 'Please select a state/region';
            return;
        }
        this.loading = true;
        store.checkout.ship.ignoreCorrection = false;
        if (isCheckoutRedesign(store.checkout.isMyFrames)) {
            // Submitting the card makes its billing checkbox the shopper's decision: Shipping method then goes straight
            // to Payment when it is ticked, and stops on the Billing address card when it is not.
            markBillingChoice();
        }

        let success = await checkout('cc-ship-addr-submit');
        checkoutUtil.checkDefaultShipping();
        success = await checkout('cc-ship-select-no-change');
        runInAction(() => {
            // approved ria
            this.loading = false;
        });
    };

    @action
    syncMore = async () => {
        store.checkout.ship.addr.addrShowMore = true;
        await checkout('checkout-sync');
    };

    @action
    syncMoreCompany = async () => {
        store.checkout.ship.addr.addrShowMoreCompany = true;
        await checkout('checkout-sync');
    };

    @action
    placesInit = async () => {
        var x = document.getElementsByClassName('google-places');

        // console.log(x);
        for (var i = 0; i < x.length; i++) {
            const ele = x[i] as HTMLInputElement;
            // console.log(ele);
            const a = document.createElement('DIV');
            a.setAttribute('id', `${ele.id}-autocomplete-list`);
            a.setAttribute('class', 'autocomplete-items');
            a.setAttribute('role', 'listbox');
            (ele.parentNode as Node).appendChild(a);
            ele.dataset.ac = `${ele.id}-autocomplete-list`;

            const onPlacesInput = () => {
                clearTimeout(s.places_throttle);
                s.places_throttle = setTimeout(async () => {
                    await checkout('places-autocomplete');
                    // _ac[this.id].list = store.checkout.ship.google_autocomplete;
                    const result = store.checkout.ship.google_autocomplete ?? [];
                    const xx = document.getElementsByClassName('google-places');
                    a.innerHTML = '';
                    // DF4's site search (app.ts closeAllLists, on pages with the site header) removes every
                    // .autocomplete-items list on any click, the tap into this field included.
                    if (!a.isConnected) {
                        (ele.parentNode as Node).appendChild(a);
                    }
                    // console.log(result);

                    for (i = 0; i < result.length; i++) {
                        const b = document.createElement('DIV');
                        b.innerHTML = result[i].description;
                        b.dataset.placeid = result[i].place_id;
                        /*execute a function when someone clicks on the item value (DIV element):*/
                        b.addEventListener('click', async function (e: any) {
                            const placeid = e.currentTarget?.dataset?.placeid;
                            if (!placeid) return;
                            store.checkout.ship.google_autocomplete_placeid = placeid;
                            await checkout('places-autocomplete-select');
                            a.innerHTML = '';

                            // Empty when the place lookup failed: keep what the shopper typed.
                            const details = store.checkout.ship.google_autocomplete_details ?? [];
                            if (details.length === 0) return;

                            try {
                                // set address
                                let street_number: string = '';
                                let street_route: string = '';
                                let street2_room: string = '';
                                let street2_floor: string = '';
                                let street2_sub: string = '';
                                let postal_first: string = '';
                                let postal_last: string = '';
                                let city: string = '';
                                let _state: string = '';
                                let _country: string = '';
                                // console.log(store.checkout.ship.google_autocomplete_details);
                                for (let i = 0; i < details.length; i++) {
                                    const d = details[i];
                                    const types = d.types ?? [];
                                    for (let z = 0; z < types.length; z++) {
                                        const t = types[z].toLowerCase();
                                        if (t === 'street_number') {
                                            street_number = d.long_name;
                                        } else if (t === 'route') {
                                            street_route = d.short_name;
                                        } else if (t === 'locality') {
                                            city = d.long_name;
                                        } else if (t === 'administrative_area_level_1') {
                                            _state = d.short_name;
                                        } else if (t === 'country') {
                                            _country = d.short_name;
                                        } else if (t === 'room') {
                                            street2_room = d.long_name;
                                        } else if (t === 'subpremise') {
                                            street2_sub = d.long_name;
                                        } else if (t === 'floor') {
                                            street2_floor = d.long_name;
                                        } else if (t === 'postal_code') {
                                            postal_first = d.long_name;
                                        } else if (t === 'postal_code_suffix') {
                                            postal_last = d.long_name;
                                        }
                                    }
                                }

                                store.checkout.ship.addr.address1.value = `${street_number} ${street_route}`;
                                // A place Google gives no city for keeps the one the shopper typed.
                                if (city.length > 0) {
                                    store.checkout.ship.addr.city.value = city;
                                }
                                store.checkout.ship.addr.state.value = _state;
                                store.checkout.ship.addr.country.value = _country;
                                if (postal_first.length > 0) {
                                    store.checkout.ship.addr.postalCode.value = postal_first;
                                }
                                if (postal_last.length > 0) {
                                    store.checkout.ship.addr.postalCode.value += `-${postal_last}`;
                                }
                            } catch (err4) {
                                logger.error(err4);
                            }
                        });
                        b.setAttribute('aria-label', `Select Automatically Completed Address: ${result[i].description}`);
                        b.setAttribute('role', 'option');
                        a.appendChild(b);
                    }

                    const b = document.createElement('DIV');
                    b.innerHTML = `Powered by <img src="https://${Portal?.CDNDomain}/images/cached/general/google_on_white.png" style="width:auto;" alt="Google" />`;
                    b.style.fontStyle = 'italic';
                    b.style.paddingLeft = '6px';
                    b.style.fontSize = '14px';
                    a.appendChild(b);

                    setTimeout(function () {
                        a.innerHTML = '';
                    }, 7000);
                }, 100);
            };
            ele.addEventListener('input', onPlacesInput);
            this.placesInputListeners.push({el: ele, handler: onPlacesInput});
        }
    };

    stateOptions() {
        return stateOptions(store.checkout.ship.addr.country.value);
    }

    fieldId(o: {autocomplete: string}) {
        return checkoutFieldDomIds(o.autocomplete, store.checkout.ab).inputId;
    }

    renderRedesign() {
        const ship = store.checkout.ship;
        const addr = ship.addr;
        const ab = store.checkout.ab;
        const showCompany = ship.addressType === ICheckoutAddressType.business || addr.addrShowMoreCompany;
        const required = <span className="ab-req">*</span>;

        return (
            <div className="shipping-write ab-ship-form">
                {store.checkout.AddressBookAddresses != null && store.checkout.AddressBookAddresses.length > 0 && (
                    <div className="ab-fields">
                        <div className="ab-field ab-full">
                            <label htmlFor="shipping-address-book">Address book</label>
                            <select
                                id="shipping-address-book"
                                className="form-select"
                                name="shipping-address-book"
                                autoComplete="off"
                                value={ship.AddressID}
                                aria-label="Address Book"
                                onChange={e => this.handleChangeAddressBook(e)}
                            >
                                <option value={-1}>Select Address</option>
                                {store.checkout.AddressBookAddresses.map(e => (
                                    <option
                                        value={e.AddressID}
                                        key={e.AddressID}
                                    >
                                        {e.Nickname}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                )}

                <div className="ab-fields">
                    <div className="ab-field">
                        <label htmlFor={this.fieldId(addr.firstName)}>First name {required}</label>
                        <CheckoutInputElement
                            ab={ab}
                            o={addr.firstName}
                            required={true}
                            ariaLabel="Shipping First Name"
                            placeholderOverride="Enter"
                        />
                    </div>
                    <div className="ab-field">
                        <label htmlFor={this.fieldId(addr.lastName)}>Last name {required}</label>
                        <CheckoutInputElement
                            ab={ab}
                            o={addr.lastName}
                            required={true}
                            ariaLabel="Shipping Last Name"
                            placeholderOverride="Enter"
                        />
                    </div>
                </div>

                {showCompany && (
                    <div className="ab-fields">
                        <div className="ab-field ab-full">
                            <label htmlFor={this.fieldId(addr.companyName)}>Company</label>
                            <CheckoutInputElement
                                ab={ab}
                                o={addr.companyName}
                                required={false}
                                ariaLabel="Shipping Company"
                                placeholderOverride="Enter"
                            />
                        </div>
                    </div>
                )}

                <div className="ab-fields">
                    <div className="ab-field ab-full">
                        <label htmlFor={this.fieldId(addr.address1)}>Address</label>
                        <CheckoutInputElement
                            ab={ab}
                            o={addr.address1}
                            required={true}
                            places={true}
                            ariaLabel="Shipping Address Line 1"
                            placeholderOverride="Address line"
                        />
                        <div className="ab-hint">Include apartment, suite, or unit if applicable</div>
                    </div>
                </div>

                {addr.addrShowMore && (
                    <div className="ab-fields ab-fields-line2">
                        <div className="ab-field ab-full">
                            <label htmlFor={this.fieldId(addr.address2)}>Address line 2</label>
                            <CheckoutInputElement
                                ab={ab}
                                o={addr.address2}
                                required={false}
                                ariaLabel="Shipping Address Line 2"
                                placeholderOverride="Apt, suite, unit, floor, etc."
                            />
                        </div>
                    </div>
                )}

                {(!addr.addrShowMore || !addr.addrShowMoreCompany) && (
                    <div className="ab-add-links">
                        {!addr.addrShowMore && (
                            <button
                                type="button"
                                className="ab-add-link"
                                onClick={this.syncMore}
                                aria-label="Add shipping address line 2"
                            >
                                <i
                                    className="fas fa-plus"
                                    aria-hidden={true}
                                />
                                Add address line
                            </button>
                        )}
                        {!addr.addrShowMoreCompany && (
                            <button
                                type="button"
                                className="ab-add-link"
                                onClick={this.syncMoreCompany}
                                aria-label="Add shipping company"
                            >
                                <i
                                    className="fas fa-plus"
                                    aria-hidden={true}
                                />
                                Add company
                            </button>
                        )}
                    </div>
                )}

                <div className="ab-fields ab-cols-3">
                    <div className="ab-field">
                        <label htmlFor={this.fieldId(addr.city)}>City</label>
                        <CheckoutInputElement
                            ab={ab}
                            o={addr.city}
                            required={true}
                            ariaLabel="Shipping City"
                            placeholderOverride="Enter"
                        />
                    </div>

                    <div className="ab-field">
                        <label htmlFor={this.isCountryWithStates ? 'shipping-states' : 'shipping-region'}>State or region</label>
                        {this.isCountryWithStates ? (
                            <select
                                id="shipping-states"
                                name="shipping-states"
                                className="form-select"
                                value={addr.state.value}
                                onChange={this.handleChangeShippingState}
                                autoComplete="shipping address-level1"
                                aria-label="Shipping State or Region"
                            >
                                {this.stateOptions()}
                            </select>
                        ) : (
                            <input
                                id="shipping-region"
                                name="shipping-region"
                                className="form-control"
                                value={addr.state.value}
                                onChange={e => (addr.state.value = e.target.value)}
                                placeholder="Enter"
                                type="text"
                                autoComplete="shipping address-level1"
                                aria-label="Shipping State or Region"
                            />
                        )}
                        {addr.state.valid.isError && <div className="input-error">{addr.state.valid.msg}</div>}
                    </div>

                    <div className="ab-field">
                        <label htmlFor={this.fieldId(addr.postalCode)}>Postal code</label>
                        <CheckoutInputElement
                            ab={ab}
                            o={addr.postalCode}
                            type="text"
                            required={true}
                            hideSpinner={true}
                            ariaLabel="Shipping Postal Code"
                            placeholderOverride="Enter"
                        />
                    </div>
                </div>

                <div className="ab-fields">
                    <div className="ab-field ab-full">
                        <label htmlFor="shipping-country">Country</label>
                        <select
                            id="shipping-country"
                            className="form-select"
                            name="shipping-country"
                            autoComplete="shipping country"
                            value={addr.country.value}
                            aria-label="Shipping Country"
                            onChange={this.handleChangeCountry}
                        >
                            {redesignCountryList().map(e => (
                                <option
                                    value={e.code}
                                    key={e.id}
                                >
                                    {e.name}
                                </option>
                            ))}
                        </select>
                        {addr.country.valid.isError && <div className="input-error">{addr.country.valid.msg}</div>}
                    </div>
                </div>

                <div className="ab-business-row">
                    <label className="ab-optin">
                        <input
                            type="checkbox"
                            aria-label="Business Address"
                            name="shipping-business-address"
                            checked={addr.isBusinessAddress}
                            onChange={() => (addr.isBusinessAddress = !addr.isBusinessAddress)}
                        />
                        <span>Business address</span>
                    </label>
                    <ModalSimple
                        id="modal-apo"
                        title={'Military APO, FPO, or DPO Address Tips'}
                    >
                        {this.renderApoTips()}
                    </ModalSimple>
                    <button
                        type="button"
                        className="ab-tips-link"
                        onClick={() => modalOpen('modal-apo')}
                        aria-label="View Military APO / FPO / DPO address tips"
                    >
                        Military (APO &amp; FPO) or DPO Address Tips
                    </button>
                </div>

                <div className="ab-billing-same-ship">
                    <label className="ab-optin">
                        <input
                            type="checkbox"
                            name="shipping-billing-same"
                            aria-label="Billing address is the same as the shipping address"
                            checked={store.checkout.billing.addrSameAsShip}
                            onChange={this.toggleBillingSameAsShip}
                        />
                        <span>My billing address is the same as my shipping address</span>
                    </label>
                    <div className="ab-hint ab-billing-same-hint">{store.checkout.billing.addrSameAsShip ? 'For your protection, the billing address must match what appears on your credit card or bank statement.' : "You'll enter your billing address after choosing a shipping method."}</div>
                </div>

                {ship.messages.map((e, i) => (
                    <div
                        className="alert alert-danger"
                        key={i.toString()}
                    >
                        <span style={{paddingRight: 6}}>
                            <i
                                className="fas fa-exclamation-square"
                                aria-hidden={true}
                            ></i>
                        </span>{' '}
                        {e.msg}
                    </div>
                ))}

                {store.checkout.cstep === ICheckoutStep.shipping && (
                    <div className="ab-step-actions">
                        <div
                            aria-live="assertive"
                            aria-atomic="true"
                            className="sr-only"
                        >
                            {this.loading ? 'Calculating shipping price' : ''}
                        </div>
                        <button
                            type="button"
                            className="btn-checkout btn-checkout-yellow"
                            onClick={this.save}
                            disabled={this.loading}
                            aria-busy={this.loading}
                            aria-label="Continue to shipping method"
                        >
                            {this.loading ? 'Calculating' : 'Continue to shipping method'}
                            {this.loading && (
                                <span className="pad-left">
                                    <i className="fas fa-circle-notch fa-spin fast-spin fa-checkout-button"></i>
                                </span>
                            )}
                        </button>
                    </div>
                )}
            </div>
        );
    }

    renderApoTips() {
        return (
            <div>
                <div className="b">Address Field</div>
                <div>For Army, Navy, and Marines enter your unit # and box #</div>
                <div>For ships, enter the ship name and hull #</div>
                <div>For Air Force, enter the PSC # and box #</div>

                <div className="b mt-2">City Field</div>
                <div>Enter APO for Air/Army Post Office</div>
                <div>Enter FPO for Fleet Post Office</div>
                <div>Enter DPO for Diplomatic Post Office</div>

                <div className="b mt-2">Stage/Region Field</div>
                <div>Armed Forces Africa (AE)</div>
                <div>Armed Forces Americas (AA)</div>
                <div>Armed Forces Canada (AE)</div>
                <div>Armed Forces Europe (AE)</div>
                <div>Armed Forces Middle East (AE)</div>
                <div>Armed Forces Pacific (AP)</div>

                <div className="b mt-2">Sample Military Address #1</div>
                <div>CPT ROBERT SMITH</div>
                <div>UNIT 2050 BOX 4190</div>
                <div>APO AP 96278</div>

                <div className="b mt-2">Sample Military Address #2</div>
                <div>SEAMAN JOSEPH SMITH</div>
                <div>USCGC HAMILTON</div>
                <div>FPO AP 96667</div>
            </div>
        );
    }

    // todo APO, privacy warning, country/international
    render() {
        if (isCheckoutRedesign(store.checkout.isMyFrames)) {
            return this.renderRedesign();
        }

        return (
            <div className="shipping-write">
                <div className="">
                    <div className="row">
                        <div className="col-12 required">* Required</div>
                    </div>

                    {/* Address Book */}
                    {store.checkout.AddressBookAddresses != null && store.checkout.AddressBookAddresses.length > 0 && (
                        <div className={'col-12 mb-2'}>
                            {store.checkout.ab < 0 && <div className={this.focusedAddressBook ? 'input-label input-label-focused' : 'input-label'}>Address Book</div>}
                            <div className="form-floating">
                                <select
                                    id="shipping-address-book"
                                    className="form-select"
                                    name="shipping-address-book"
                                    onFocus={() => (this.focusedAddressBook = true)}
                                    onBlur={() => (this.focusedAddressBook = false)}
                                    autoComplete="off"
                                    value={store.checkout.ship.AddressID}
                                    aria-label="Address Book"
                                    onChange={e => this.handleChangeAddressBook(e)}
                                >
                                    <option
                                        value={-1}
                                        key={-1}
                                    >
                                        Select Address
                                    </option>
                                    {store.checkout.AddressBookAddresses.map(e => (
                                        <option
                                            value={e.AddressID}
                                            key={e.AddressID}
                                        >
                                            {e.Nickname}
                                        </option>
                                    ))}
                                </select>
                                <label htmlFor="shipping-address-book">Address Book</label>
                            </div>
                        </div>
                    )}

                    {/* Shipping first and last names */}
                    <div className="row pad-top">
                        <div className="col-12 col-sm-6">
                            <CheckoutInputElement
                                floating={true}
                                ab={store.checkout.ab}
                                o={store.checkout.ship.addr.firstName}
                                label="First Name"
                                required={true}
                                ariaLabel="Shipping First Name"
                            />
                        </div>
                        <div className="col-12 col-sm-6">
                            <CheckoutInputElement
                                floating={true}
                                ab={store.checkout.ab}
                                o={store.checkout.ship.addr.lastName}
                                required={true}
                                ariaLabel="Shipping Last Name"
                            />
                        </div>
                    </div>

                    {/* companyName */}
                    <div className="row">
                        {(store.checkout.ship.addressType === ICheckoutAddressType.business || store.checkout.ship.addr.addrShowMoreCompany) && (
                            <div className="col-12">
                                <CheckoutInputElement
                                    floating={true}
                                    ab={store.checkout.ab}
                                    o={store.checkout.ship.addr.companyName}
                                    required={false}
                                    ariaLabel="Shipping Company"
                                />
                            </div>
                        )}
                    </div>

                    {/* address line 1 */}
                    <div className="row">
                        <div className="col-12">
                            <CheckoutInputElement
                                floating={true}
                                ab={store.checkout.ab}
                                o={store.checkout.ship.addr.address1}
                                required={true}
                                places={true}
                                ariaLabel="Shipping Address Line 1"
                            />
                        </div>
                    </div>

                    {/* address line 2 */}
                    <div className="row">
                        {store.checkout.ship.addr.addrShowMore && (
                            <div className="col-12">
                                <CheckoutInputElement
                                    floating={true}
                                    ab={store.checkout.ab}
                                    o={store.checkout.ship.addr.address2}
                                    required={false}
                                    placeholder="Apartment, suite, unit, building, floor, etc"
                                    ariaLabel="Shipping Address Line 2"
                                />
                            </div>
                        )}
                        {!store.checkout.ship.addr.addrShowMore && (
                            <div className="col-12">
                                <button
                                    className="add-more text-btn"
                                    onClick={this.syncMore}
                                    type="button"
                                    aria-label="Add shipping address line 2"
                                >
                                    + Add Address Line 2
                                </button>
                            </div>
                        )}
                        {!store.checkout.ship.addr.addrShowMoreCompany && (
                            <div className="col-12">
                                <button
                                    className="add-more text-btn"
                                    onClick={this.syncMoreCompany}
                                    type="button"
                                    aria-label="Add shipping company"
                                >
                                    + Add Company
                                </button>
                            </div>
                        )}
                    </div>

                    <div className="row pad-top">
                        {/* city */}
                        <div className={this.isCountryWithStates ? 'col-12 col-sm-4 col-lg-4' : 'col-12 col-sm-4'}>
                            <CheckoutInputElement
                                floating={true}
                                ab={store.checkout.ab}
                                o={store.checkout.ship.addr.city}
                                required={true}
                                ariaLabel="Shipping City"
                            />
                        </div>

                        {/* state */}
                        <div className={this.isCountryWithStates ? 'col-12 col-sm-5 col-lg-3' : 'col-12 col-sm-4'}>
                            {store.checkout.ab < 0 && <div className={this.focusedState ? 'input-label input-label-focused' : 'input-label'}>* State/Region</div>}
                            {this.isCountryWithStates && (
                                <div className="form-floating">
                                    <select
                                        id="shipping-states"
                                        onFocus={() => (this.focusedState = true)}
                                        onBlur={() => (this.focusedState = false)}
                                        name="shipping-states"
                                        className="form-select"
                                        value={store.checkout.ship.addr.state.value}
                                        onChange={this.handleChangeShippingState}
                                        autoComplete="shipping address-level1"
                                        aria-label="Shipping State or Region"
                                    >
                                        {this.stateOptions()}
                                    </select>
                                    <label htmlFor="shipping-states">State or Region</label>
                                </div>
                            )}
                            {!this.isCountryWithStates && (
                                <div className="form-floating">
                                    <input
                                        value={store.checkout.ship.addr.state.value}
                                        onChange={e => (store.checkout.ship.addr.state.value = e.target.value)}
                                        onFocus={() => (this.focusedState = true)}
                                        onBlur={() => (this.focusedState = false)}
                                        className="form-control"
                                        placeholder="State/Region"
                                        type="text"
                                        autoComplete="shipping address-level1"
                                        aria-label="Shipping State or Region"
                                        name="shipping-region"
                                        id="shipping-region"
                                    />
                                    <label htmlFor="shipping-region">State or Region</label>
                                </div>
                            )}
                            {store.checkout.ship.addr.state.valid.isError && (
                                <div
                                    className="error"
                                    style={{
                                        color: '#FE0000',
                                        paddingLeft: '17px',
                                        fontSize: '14px',
                                    }}
                                >
                                    {store.checkout.ship.addr.state.valid.msg}
                                </div>
                            )}
                        </div>

                        {/* postal code */}
                        <div className={this.isCountryWithStates ? 'col-12 col-sm-3 col-lg-5 col-postal-code' : 'col-12 col-sm-4 col-postal-code'}>
                            <CheckoutInputElement
                                floating={true}
                                ab={store.checkout.ab}
                                o={store.checkout.ship.addr.postalCode}
                                type="text"
                                required={true}
                                hideSpinner={true}
                                ariaLabel="Shipping Postal Code"
                            />
                        </div>

                        {/* country */}
                        <div className={'col-12'}>
                            {store.checkout.ab < 0 && <div className={this.focusedCountry ? 'input-label input-label-focused' : 'input-label'}>* Country</div>}
                            <div className="form-floating">
                                <select
                                    id="shipping-country"
                                    className="form-select"
                                    name="shipping-country"
                                    onFocus={() => (this.focusedCountry = true)}
                                    onBlur={() => (this.focusedCountry = false)}
                                    autoComplete="shipping country"
                                    value={store.checkout.ship.addr.country.value}
                                    aria-label="Shipping Country"
                                    onChange={this.handleChangeCountry}
                                >
                                    {data.countries.map(e => (
                                        <option
                                            value={e.code}
                                            key={e.id}
                                        >
                                            {e.name}
                                        </option>
                                    ))}
                                </select>
                                <label htmlFor="shipping-country">Country</label>
                            </div>
                            {store.checkout.ship.addr.country.valid.isError && (
                                <div
                                    className="error"
                                    style={{
                                        color: '#FE0000',
                                        paddingLeft: '17px',
                                        fontSize: '14px',
                                    }}
                                >
                                    {store.checkout.ship.addr.country.valid.msg}
                                </div>
                            )}
                        </div>

                        <div className="col-12 col-md-6 text-left mt-1">
                            <label className="radio-container">
                                <input
                                    type="checkbox"
                                    aria-label="Business Address"
                                    className="radio radio-sm"
                                    name="shipping-business-address"
                                    value={1}
                                    checked={store.checkout.ship.addr.isBusinessAddress}
                                    onChange={() => (store.checkout.ship.addr.isBusinessAddress = !store.checkout.ship.addr.isBusinessAddress)}
                                />
                                <span className="radio-label">Business Address</span>
                            </label>
                        </div>

                        <div className="col-12 col-md-6 text-right mt-1">
                            <ModalSimple
                                id="modal-apo"
                                title={'Military APO, FPO, or DPO Address Tips'}
                            >
                                <div>
                                    <div className="b">Address Field</div>
                                    <div>For Army, Navy, and Marines enter your unit # and box #</div>
                                    <div>For ships, enter the ship name and hull #</div>
                                    <div>For Air Force, enter the PSC # and box #</div>

                                    <div className="b mt-2">City Field</div>
                                    <div>Enter APO for Air/Army Post Office</div>
                                    <div>Enter FPO for Fleet Post Office</div>
                                    <div>Enter DPO for Diplomatic Post Office</div>

                                    <div className="b mt-2">Stage/Region Field</div>
                                    <div>Armed Forces Africa (AE)</div>
                                    <div>Armed Forces Americas (AA)</div>
                                    <div>Armed Forces Canada (AE)</div>
                                    <div>Armed Forces Europe (AE)</div>
                                    <div>Armed Forces Middle East (AE)</div>
                                    <div>Armed Forces Pacific (AP)</div>

                                    <div className="b mt-2">Sample Military Address #1</div>
                                    <div>CPT ROBERT SMITH</div>
                                    <div>UNIT 2050 BOX 4190</div>
                                    <div>APO AP 96278</div>

                                    <div className="b mt-2">Sample Military Address #2</div>
                                    <div>SEAMAN JOSEPH SMITH</div>
                                    <div>USCGC HAMILTON</div>
                                    <div>FPO AP 96667</div>
                                </div>
                            </ModalSimple>
                            <button
                                className="link text-btn"
                                style={{fontSize: 12}}
                                onClick={() => modalOpen('modal-apo')}
                                aria-label="View Military APO / FPO / DPO address tips"
                                type="button"
                            >
                                Military (APO &amp; FPO) or DPO Address Tips
                            </button>
                        </div>
                    </div>

                    {store.checkout.ship.messages.map((e, i) => (
                        <div
                            className="alert alert-danger"
                            key={i.toString()}
                            style={{marginTop: 8}}
                        >
                            <span style={{paddingRight: 6}}>
                                <i
                                    className="fas fa-exclamation-square"
                                    aria-hidden={true}
                                ></i>
                            </span>{' '}
                            {e.msg}
                        </div>
                    ))}

                    <div className="row row-ship-continue">
                        {store.checkout.cstep === ICheckoutStep.shipping && (
                            <div className="col-12 text-right">
                                <div
                                    aria-live="assertive"
                                    aria-atomic="true"
                                    className="sr-only"
                                >
                                    {this.loading ? 'Calculating shipping price' : ''}
                                </div>
                                <button
                                    type="button"
                                    className={`btn-checkout btn-checkout-yellow${Portal?.PortalID === 3 ? ' btn-checkout-yellow-portal3' : ''}`}
                                    onClick={this.save}
                                    disabled={this.loading}
                                    aria-busy={this.loading}
                                    aria-label="Save and Continue"
                                >
                                    {!this.loading ? 'Save & Continue' : 'Calculating'}
                                    {this.loading && (
                                        <span className="pad-left">
                                            <i className="fas fa-circle-notch fa-spin fast-spin fa-checkout-button"></i>
                                        </span>
                                    )}
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}
